import { render, staticRenderFns } from "./Move.vue?vue&type=template&id=eb427eda&scoped=true&"
import script from "./Move.vue?vue&type=script&lang=js&"
export * from "./Move.vue?vue&type=script&lang=js&"
import style0 from "./Move.vue?vue&type=style&index=0&id=eb427eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb427eda",
  null
  
)

export default component.exports